export default __webpack_public_path__ + "static/media/lifestyle.22ae31cd.svg";